<loading [visible]="loading() || saving()"></loading>

@if(!loading()){
<app-custom-modal customTitle="Configuración IMAP" (closeFunction)="closeFormFunction()"
    (acceptFunction)="acceptFormFunction()">
    <form [formGroup]="saveForm" (ngSubmit)="saveEntity()" class="space-y-4">

        <custom-input label="Servidor IMAP" type="text" placeholder="imap.hostinger.com"
            [formControlItem]="saveForm.get('host')">
        </custom-input>

        <custom-input label="Puerto" type="number" placeholder="993"
            [formControlItem]="saveForm.get('port')">
        </custom-input>

        <custom-input label="Usuario (email)" type="email" placeholder="info@empresa.com"
            [formControlItem]="saveForm.get('username')">
        </custom-input>

        <custom-input label="Contraseña" type="password"
            [formControlItem]="saveForm.get('password')">
        </custom-input>

        <custom-input label="Carpeta de borradores" type="text" placeholder="Drafts"
            [formControlItem]="saveForm.get('drafts_folder')">
        </custom-input>

    </form>
</app-custom-modal>
}
